import { ISettingInfo, IWritableSettings } from '@barthauer/abc/core';
import { ProfileInfo } from './profile-info.model';

export enum ProfileSetting {
  id,
  displayText,
  description,
  mapImagePreview,
  contextIdentifier,
}

export interface IProfileSettings {
  readonly id: string;
  readonly displayText: string;
  readonly description: string;
  readonly mapImagePreview: string;
  readonly contextIdentifier: string;
  toProfileInfo(isCurrent?: boolean, settings?: any, mapImagePreview?: string, description?: string): ProfileInfo;
}

export class ProfileSettings implements IProfileSettings, IWritableSettings<IProfileSettings> {
  public static readonly Infos: ReadonlyMap<ProfileSetting, ISettingInfo> = new Map<ProfileSetting, ISettingInfo>([
    [ProfileSetting.id, { settingName: 'id', responsePropertyName: 'Id', settingValueType: String, isOptional: false }],
    [
      ProfileSetting.displayText,
      { settingName: 'displayText', responsePropertyName: 'DisplayText', settingValueType: String, isOptional: false },
    ],
    [
      ProfileSetting.description,
      { settingName: 'description', responsePropertyName: 'Description', settingValueType: String, isOptional: true },
    ],
    [
      ProfileSetting.mapImagePreview,
      {
        settingName: 'mapImagePreview',
        responsePropertyName: 'MapImagePreview',
        settingValueType: String,
        isOptional: true,
      },
    ],
    [
      ProfileSetting.contextIdentifier,
      {
        settingName: 'contextIdentifier',
        responsePropertyName: 'ContextIdentifier',
        settingValueType: String,
        isOptional: true,
      },
    ],
  ]);

  constructor(profileSettingsOrInfo?: IProfileSettings | ProfileInfo) {
    this.load(profileSettingsOrInfo);
  }
  public id: string;
  public displayText: string;
  public description: string;
  public mapImagePreview: string;
  public contextIdentifier: string;

  public toProfileInfo(
    isCurrent?: boolean,
    settings?: any,
    mapImagePreview?: string,
    description?: string
  ): ProfileInfo {
    return new ProfileInfo(this.id, this.displayText, isCurrent, settings, mapImagePreview, description);
  }

  public load(profileSettingsOrInfo: IProfileSettings | ProfileInfo): void {
    if (profileSettingsOrInfo) {
      this.id = profileSettingsOrInfo.id;
      this.displayText = profileSettingsOrInfo.displayText;
      this.description = profileSettingsOrInfo.description;
      this.mapImagePreview = profileSettingsOrInfo.mapImagePreview;
      this.contextIdentifier = (<any>profileSettingsOrInfo).contextIdentifier;
    }
  }
}
